import { render, staticRenderFns } from "./FeedbackPanelCollapsedButton.vue?vue&type=template&id=2024f574&scoped=true&"
import script from "./FeedbackPanelCollapsedButton.vue?vue&type=script&lang=js&"
export * from "./FeedbackPanelCollapsedButton.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPanelCollapsedButton.vue?vue&type=style&index=0&id=2024f574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024f574",
  null
  
)

export default component.exports